import { Button } from 'antd';
import styled from 'styled-components';

export const AddDescriptionButton = styled(Button)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 0;
  height: fit-content;
`;
